var _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgCatchu4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.9543,
    cy: 33.4437,
    rx: 10.1354,
    ry: 1.11073,
    fill: "#1C1C1C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.70874 30.6978V15.4122C9.70874 15.4122 9.96628 8.50859 15.9173 6.26065C21.8684 4.01272 26.1454 6.67755 28.719 10.4682C28.8643 10.7969 30.2551 12.1137 30.198 17.4361V29.6712C30.198 29.6712 29.9405 27.5518 29.5542 28.6758C29.1679 29.7997 28.5571 33.8457 26.7874 32.1432C26.7874 32.1432 25.1796 30.1836 24.1826 31.4361C23.1855 32.6886 21.8353 34.7107 20.3875 34.0367C18.9398 33.3627 17.5251 30.1505 15.7242 31.9816C13.9232 33.8126 12.8287 33.5555 11.896 31.179C10.9633 28.8025 10.7389 28.6427 9.70874 30.6978Z",
    fill: "#E2E0EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.465 18.412C20.7902 18.412 21.0538 18.1484 21.0538 17.8232C21.0538 17.498 20.7902 17.2344 20.465 17.2344C20.1398 17.2344 19.8762 17.498 19.8762 17.8232C19.8762 18.1484 20.1398 18.412 20.465 18.412Z",
    fill: "#010202"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9175 6.26065C15.0492 6.5894 14.3042 7.01915 13.6603 7.50951L13.6401 7.55359C13.6401 7.55359 18.4322 4.44798 22.7571 6.90345C27.0819 9.35892 29.0098 13.1643 29.0429 17.8879C29.0687 21.561 29.054 27.8714 29.0466 30.4921C29.2655 29.7759 29.4237 29.0578 29.5543 28.6758C29.9406 27.5518 30.1982 29.6712 30.1982 29.6712V17.4361C30.2552 12.1137 28.8645 10.7951 28.7192 10.4682C26.1456 6.67755 21.8667 4.01272 15.9175 6.26065Z",
    fill: "#BEB9CF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3841 17.8388C15.7093 17.8388 15.9729 17.5752 15.9729 17.25C15.9729 16.9248 15.7093 16.6611 15.3841 16.6611C15.0589 16.6611 14.7952 16.9248 14.7952 17.25C14.7952 17.5752 15.0589 17.8388 15.3841 17.8388Z",
    fill: "#010202"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1677 9.91149C14.6479 9.28852 14.8009 8.60196 14.5095 8.37802C14.218 8.15408 13.5924 8.47756 13.1122 9.10053C12.632 9.7235 12.479 10.4101 12.7704 10.634C13.0619 10.8579 13.6875 10.5345 14.1677 9.91149Z",
    fill: "#F4F3F0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6102 18.9365L19.5856 19.2708C19.5856 19.2708 19.4458 19.5609 19.1514 19.8585C18.8111 20.2019 18.2629 20.5545 17.4829 20.4847C16.0223 20.3543 15.6102 18.9365 15.6102 18.9365Z",
    fill: "#040000"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7823 20.2992C16.9829 20.3928 17.2147 20.459 17.4814 20.4828C18.2632 20.5526 18.8114 20.2 19.1499 19.8566C19.1499 19.8584 17.7573 19.5462 16.7823 20.2992Z",
    fill: "#D15F53"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7022 19.4178L17.9505 19.4307C17.9928 19.4325 18.0296 19.3994 18.0333 19.3572L18.0443 19.1423L17.6304 19.1074L17.6286 19.3407C17.6286 19.3811 17.6599 19.416 17.7022 19.4178Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1519 19.0664L17.1225 19.3235C17.1207 19.3456 17.1409 19.3658 17.1703 19.3694L17.4665 19.4043C17.4959 19.408 17.5217 19.3933 17.5254 19.3694L17.5677 19.0995L17.1519 19.0664Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgCatchu4);
export default __webpack_public_path__ + "static/media/img_catchu-4.b15312ed3f4a45e638418fab56f7129a.svg";
export { ForwardRef as ReactComponent };